<script setup lang="ts">
const props = withDefaults(defineProps<SimpleButtonProp>(), {
    icon: "",
    color: ButtonColor.primary,
    size: ButtonSize.default,
    mode: ButtonColorMode.normal,
    boldness: TextBoldness.normal,
    outlined: false,
    inverted: false,
    rounded: false,
});

const classes: Array<string> = [
    "button",
    `is-${props.color}`,
    `is-${props.size}`,
    `has-text-weight-${props.boldness}`,
];
if (props.mode === ButtonColorMode.dark) {
    classes.push("is-dark");
} else if (props.mode === ButtonColorMode.light) {
    classes.push("is-light");
}
if (props.outlined) {
    classes.push("is-outlined");
}
if (props.inverted) {
    classes.push("is-inverted");
}
if (props.rounded) {
    classes.push("is-rounded");
}

function getIconClasses(): string[] {
    const iconClasses: string[] = ["material-icons"];
    if (props.outlined) {
        iconClasses.push("material-icons-outlined");
    }
    return iconClasses;
}
</script>

<script lang="ts">
export enum ButtonColor {
    white = "white",
    light = "light",
    dark = "dark",
    black = "black",
    text = "text",
    ghost = "ghost",
    primary = "primary",
    link = "link",
    info = "info",
    success = "success",
    warning = "warning",
    danger = "danger",
}

export enum ButtonSize {
    small = "small",
    default = "default",
    normal = "normal",
    medium = "medium",
    large = "large",
}

export enum ButtonColorMode {
    light,
    normal,
    dark,
}

export enum TextBoldness {
    light = "light",
    normal = "normal",
    medium = "medium",
    semi_bold = "semibold",
    bold = "bold",
    extra_bold = "extrabold",
}

export interface SimpleButtonProp {
    href?: string;
    to?: string;
    icon?: string;
    color?: ButtonColor;
    size?: ButtonSize;
    mode?: ButtonColorMode;
    boldness?: TextBoldness;
    outlined?: boolean;
    inverted?: boolean;
    rounded?: boolean;
}
</script>

<template>
    <a v-if="props.href" :class="classes">
        <slot></slot>
    </a>
    <RouterLink v-else-if="props.to" :class="classes" :to="props.to">
        <slot></slot>
    </RouterLink>
    <button v-else :class="classes">
        <span v-if="props.icon !== ''" :class="getIconClasses()">
            {{ props.icon }}
        </span>
        <span style="line-height: initial">
            <slot></slot>
        </span>
    </button>
</template>